import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { Fade } from 'react-slideshow-image';
import { Media, Player } from 'react-media-player';
import './style.scss';

const SLIDESHOW_PROPS = {
	transitionDuration: 500,
	infinite: false,
	indicators: true,
	autoplay: false,
};

// Résout une image : URL directe, ou nom de fichier local dans src/img.
const localImages = require.context('../../../img', true);
const resolveImg = src =>
	src && src.indexOf('http') !== -1 ? src : localImages(`./${src}.png`);

// Média du helper : image, vidéo (fichier), vidéo YouTube (embed) ou slideshow.
const renderMedia = media => {
	if (!media || !media.value) return null;

	switch (media.key_) {
		case 'image':
			return <img src={resolveImg(media.value)} alt="" />;

		case 'video_youtube':
			return (
				<iframe
					title="step-helper-media"
					src={media.value}
					frameBorder="0"
					allowFullScreen
				/>
			);

		case 'slideshow':
			return (
				<div className="slide-container">
					<Fade {...SLIDESHOW_PROPS}>
						{(Array.isArray(media.value) ? media.value : []).map((slide, i) => (
							<div key={i} className="each-fade">
								<div className="image-container">
									<img src={resolveImg(slide)} alt="" />
								</div>
							</div>
						))}
					</Fade>
				</div>
			);

		case 'video':
			return (
				<Media>
					<div className="media-player">
						<Player src={media.value} />
					</div>
				</Media>
			);

		default:
			return null;
	}
};

/**
 * Encart d'aide affiché sous la tuile de configuration.
 * Reprend le style de l'ancien "expand-content" (média + titre + description).
 *
 * @param {Object} props.helper onboarding.step_helper { title, description[], media }
 */
const StepHelper = ({ helper }) => {
	if (!helper) return null;

	const { title, description, media } = helper;
	const mediaContent = renderMedia(media);
	const lines = Array.isArray(description) ? description : [];

	return (
		<div className="step-helper">
			{mediaContent ? (
				<div className="step-helper__media">{mediaContent}</div>
			) : null}

			<div className="step-helper__content">
				{title ? <h4 className="step-helper__title">{title}</h4> : null}
				{lines.map((line, index) => (
					<ReactMarkdown
						key={index}
						rehypePlugins={[rehypeRaw]}
						remarkPlugins={[remarkGfm]}>
						{line}
					</ReactMarkdown>
				))}
			</div>
		</div>
	);
};

export default StepHelper;
